import { init_coverage } from './coverage_plugin';

$(document).ready(function() {
    let $sectionObj = $('.global-coverage-search-widget');
    init_coverage($sectionObj);
});

jQuery(function () {

    let $coverageMenu = $('.business-search-form');
    let $startSearchAgain = $('.start-cs-again');

    $coverageMenu.on('click', function(e) {
        e.preventDefault();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event" : "Fibersearch",
            "eventCategory" : "Check Fiber",
            "eventAction" : "Click on Kan din bedrift få fiber",
            "eventLabel" : ""
        });
        showGlobalCSWidget();
    });

    $startSearchAgain.on('click', function(e) {
        e.preventDefault();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event" : "ccNewSearch",
            "eventCategory" : "Check Fiber",
            "eventAction" : "Click on Start på nytt",
            "eventLabel" : ""
        });
        showGlobalCSWidget();
    });

    function showGlobalCSWidget() {
        let $gcsWidget = $('.global-coverage-search-widget');
        $gcsWidget.toggle();

        if($('.nav-main-wrap').hasClass("active")) {
            $('.menu-toggle-button').click();
        }
        
        let $closeBtn = $gcsWidget.find('.close');
        $closeBtn.on('click', function(event) {
            event.preventDefault();
            $gcsWidget.hide();
        });
    }
});
